import { render, staticRenderFns } from "./BathPropertyIconItem.vue?vue&type=template&id=df586b86&"
import script from "./BathPropertyIconItem.vue?vue&type=script&lang=js&"
export * from "./BathPropertyIconItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports